import { Component, Input } from '@angular/core';
import { Store } from "@ngrx/store";
import { actionPanelActions } from "@store/doc-viewer/action-panel/action-panel.actions";

@Component({
    selector: 'lex-action-panel',
    templateUrl: './action-panel.component.html',
    styleUrls: ['./action-panel.component.scss'],
    standalone: false
})
export class ActionPanelComponent {
	@Input() public panelHeight: 'full' | 'dynamic' = 'dynamic';
	@Input() public includeFooter: boolean = false;
	constructor(private store: Store) {
	}

	public clear() {
		this.store.dispatch(actionPanelActions.viewUpdated({selectedView: null}));
	}
}
